import { initPage } from './init';

const filters = [];

document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener(
    'popstate',
    function (event) {
      if (history.state && history.state.id === 'filter') {
        location.reload();
      }
    },
    false
  );

  function filterLoadUrl(id, url, reload = true) {
    document
      .querySelector('.filter-results[data-id="' + id + '"]')
      .classList.add('is-loading');

    let loadUrl = url;
    if (!reload) {
      if (url.indexOf('?') !== -1) loadUrl += '&loadmore=1';
      else loadUrl += '?loadmore=1';
    }

    fetch(loadUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // push state
        if (filters[id].updateUrl) {
          const title = doc.querySelector('title').textContent;
          window.history.pushState(
            {
              id: 'filter',
            },
            title,
            url
          );
        }

        if (reload) {
          document.querySelector(
            '.filter-results[data-id="' + id + '"]'
          ).innerHTML = doc.querySelector(
            '.filter-results[data-id="' + id + '"]'
          ).innerHTML;
          // document.querySelector('.filters select[name="year"]').innerHTML =
          //   doc.querySelector('.filters select[name="year"]').innerHTML;
        } else {
          document.querySelector(
            '.filter-results[data-id="' + id + '"] .cards'
          ).innerHTML =
            document.querySelector(
              '.filter-results[data-id="' + id + '"] .cards'
            ).innerHTML +
            doc.querySelector('.filter-results[data-id="' + id + '"] .cards')
              .innerHTML;
          if (
            doc.querySelector(
              '.filter-results[data-id="' + id + '"] .load-more'
            )
          ) {
            document.querySelector(
              '.filter-results[data-id="' + id + '"] .load-more'
            ).innerHTML = doc.querySelector(
              '.filter-results[data-id="' + id + '"] .load-more'
            ).innerHTML;
          } else {
            document
              .querySelector('.filter-results[data-id="' + id + '"] .load-more')
              .remove();
          }
        }
        document
          .querySelector('.filter-results[data-id="' + id + '"]')
          .classList.remove('is-loading');

        // init filter
        filterInit(id);
        initPage();

        // activate block links
        document
          .querySelectorAll('.filter-results[data-id="' + id + '"] .block-link')
          .forEach((el) => {
            el.addEventListener('click', function (e) {
              el.querySelector('a').click();
            });
          });
      })
      .catch(function (err) {
        console.log('Failed to fetch page: ', err);
      });
  }

  function filterSearch(id, jumpToUrl = false) {
    const params = {};
    const query = {};
    let isFiltered = false;

    // loop through inputs to find values
    document
      .querySelectorAll('.filters[data-id="' + id + '"] .filter')
      .forEach((el) => {
        if (el.querySelector('.input')) {
          const id = el.getAttribute('data-id');
          const type = el.getAttribute('data-type');
          const val = el.querySelector('.input').value;
          if (val) {
            isFiltered = true;
            if (type === 'query') {
              query[id] = val;
            } else {
              params[id] = val;
            }
          }
          el.classList.toggle('is-active', val);
        }
      });

    // make url
    const globalParamsOrder = [
      'category',
      'location',
      'service',
      'sector',
      'month',
      'page',
    ];
    let url = filters[id].rootUrl;
    let sep = '';
    globalParamsOrder.forEach((key) => {
      if (params[key] !== undefined && params[key] !== 'all') {
        // if (key == 'page') {
        url += sep + key;
        sep = '/';
        // }
        url += sep + params[key];
        sep = '/';
      }
    });
    for (const key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        if (
          params[key] !== undefined &&
          params[key] !== 'all' &&
          globalParamsOrder.indexOf(key) === -1
        ) {
          url += sep + key;
          sep = '/';
          url += sep + params[key];
        }
      }
    }
    url += sep;

    // add query string
    sep = '';
    let urlQuery = '';
    for (const key in query) {
      if (Object.prototype.hasOwnProperty.call(query, key)) {
        if (query[key] !== undefined && query[key].length) {
          urlQuery += sep + key + '=' + encodeURIComponent(query[key]);
          sep = '&';
        }
      }
    }
    if (urlQuery.length) {
      if (filters[id].rootUrlHasQueryString) urlQuery = '&' + urlQuery;
      else urlQuery = '?' + urlQuery;
      url = url + urlQuery;
    }

    let newUrl = url.replace(window.location.host, '');
    newUrl = newUrl.replace(window.location.protocol, '');
    newUrl = newUrl.replace('//', '');
    const currentUrl = window.location.pathname + window.location.search;

    if (newUrl !== currentUrl) {
      if (jumpToUrl) {
        window.location.href = url;
      } else {
        filterLoadUrl(id, url);
      }
    }

    // show hide clear button
    const clearBtn = document.querySelector(
      '.filters[data-id="' + id + '"] .filter-btn'
    );
    if (clearBtn) {
      if (isFiltered) {
        clearBtn.classList.remove('filter-btn--hidden');
      } else {
        clearBtn.classList.add('filter-btn--hidden');
      }
      // clearBtn.style.visibility = isFiltered ? 'visible' : 'hidden';
    }

    return false;
  }

  function filterInit(id) {
    const filterLoadMore = document.querySelector(
      '.filter-results[data-id="' + id + '"] [data-action="filterLoadMore"]'
    );
    if (filterLoadMore) {
      filterLoadMore.addEventListener('click', function (event) {
        const url = filterLoadMore.getAttribute('href');
        filterLoadUrl(id, url, false);

        event.preventDefault();
      });
    }
  }

  document.querySelectorAll('.filters').forEach((el) => {
    const id = el.getAttribute('data-id');
    filters[id] = [];
    filters[id].rootUrl = el.getAttribute('data-rootUrl');
    filters[id].currentUrl = el.getAttribute('data-currentUrl');
    filters[id].updateUrl =
      el.getAttribute('data-updateUrl') === 'true' ?? false;
    filters[id].rootUrlHasQueryString =
      el.getAttribute('data-rootUrlHasQueryString') === 'true' ?? false;
    filterInit(id);
  });

  function filterClear(id) {
    document
      .querySelectorAll(
        '.filters[data-id="' +
          id +
          '"] .filter-select-input, .filters[data-id="' +
          id +
          '"] .filter-text-input'
      )
      .forEach((el) => {
        el.value = '';
        // el.dispatchEvent(new Event('change'));
      });
    filterSearch(id);
  }

  // filter keyword input delay
  function delay(callback, ms) {
    let timer = 0;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

  document.querySelectorAll('.filter__button').forEach((el) => {
    el.addEventListener('click', function (event) {
      el.parentNode.querySelector('.input').value =
        el.getAttribute('data-value');
      document.querySelectorAll('.filter__button').forEach((btn) => {
        btn.classList.remove('btn--filled');
      });
      el.classList.add('btn--filled');
      const id = el.closest('.filters').getAttribute('data-id');
      filterSearch(id);
      event.preventDefault();
    });
  });

  document.querySelectorAll('.filter-select-input').forEach((el) => {
    el.addEventListener(
      'change',
      delay(function (event) {
        const id = el.closest('.filters').getAttribute('data-id');
        filterSearch(id);
      }, 500)
    );
  });

  document.querySelectorAll('.filter-text-input').forEach((el) => {
    el.addEventListener(
      'keydown',
      delay(function (event) {
        if (event.key !== 'Tab') {
          const id = el.closest('.filters').getAttribute('data-id');
          filterSearch(id);
        }
      }, 500)
    );
  });

  document.querySelectorAll('.filter-btn').forEach((el) => {
    el.addEventListener('click', function (event) {
      const id = el.closest('.filters').getAttribute('data-id');
      filterClear(id);
    });
  });

  if (window.innerWidth > 1000) {
    if (document.querySelector('.filters--with-toggle')) {
      document
        .querySelector('.filters--with-toggle')
        .setAttribute('aria-hidden', false);
    }
  }

  document
    .querySelectorAll('[aria-controls="filters"], [data-type="filterToggle"]')
    .forEach((el) => {
      el.addEventListener('click', function (event) {
        if (
          document.querySelector('#filters').getAttribute('aria-hidden') ===
          'true'
        ) {
          el.querySelector('.btn__text').innerHTML = 'Filter results';
        } else {
          el.querySelector('.btn__text').innerHTML = 'Hide filter';
        }
      });
    });
});
